export interface HistoryPreviewState<T> {
  isLoading: boolean;
  loadedTimestamp?: string;
  snapshot?: T;
}

export const resolveHistoryPreviewState = <T>(
  requestedTimestamp: string | undefined,
  loadedTimestamp: string | undefined,
  snapshot: T | undefined,
  isLoading: boolean
): HistoryPreviewState<T> => {
  const isReady =
    !!requestedTimestamp &&
    loadedTimestamp === requestedTimestamp &&
    snapshot !== undefined;

  return {
    isLoading: !!requestedTimestamp && (isLoading || !isReady),
    loadedTimestamp: isReady ? loadedTimestamp : undefined,
    snapshot: isReady ? snapshot : undefined,
  };
};
